import React, { Component } from 'react';

import { History as history, Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticeInitialMessages extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeInitialMessages = (locations) => {
    const alerts = this.props.alerts || [];

    if (locations.length === 0) {
      return null;
    }

    const locationRows = locations.map((location) => {
      const messageForLocation = this.getInitalMessageForLocation(location._id, alerts);
      const buttonTitle = messageForLocation ? 'Edit Initial Message' : 'Add Initial Message';
      const rowSubTitle = messageForLocation ? 'Initial Message has been set for this location' : 'No Initial Message set for this location';
      return <div className="flex-container flex-container-row flex-space-between" style={{ marginTop: 10, marginBottom: 10 }} key={location._id}>
        <div className="flex-container flex-container-column">
          <span style={{ fontSize: 13, color: 'grey' }}>{ location.name }</span>
          <span style={{ color: 'grey', fontSize: 13, marginTop: -3 }}>{ rowSubTitle }</span>
        </div>
        <div className="flex-container flex-container-column flex-center-justify">
        <input  type="submit"
                value={buttonTitle}
                className="button-clear-blue"
                style={{ fontSize: 13 }}
                onClick={ () => {
                  const screenProps = {
                    alertType: 'initial',
                    location_id: location._id,
                    practice_id: location.practice_id,
                    alert: messageForLocation,
                  }
                  history.push({ pathname: routes.PRACTICE_ALERT_EDIT, state: { props: screenProps } })
                }}
              />
        </div>
      </div>
    })

    return <div className="standard-container">
      <Header title='Practice Initial Message(s)' icon='fas fa-envelope-open-text' />
      <div className="flex-container flex-container-column" style={{ padding: 15, paddingTop: 5 }}>
        <span style={{ color: 'grey', fontSize: 14, marginTop: 10 }}>Customized messages for when clients request a consultation</span>
        { locationRows }
      </div>
    </div>
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return this.renderPracticeInitialMessages(this.props.locations);
  }

  getInitalMessageForLocation = (location_id, alerts) => {
    var initialMessage = null;

    alerts.forEach((alert) => {
      if (alert.practice_location_id === location_id && alert.type === 'INITIAL') {
        initialMessage = alert;
      }
    });

    return initialMessage;
  }

}


export default PracticeInitialMessages
